<div class="registration-layout">
  <img alt="" src="assets/images/logo-white.svg" class="logo" />
  <div class="registration-container">
    <router-outlet></router-outlet>
  </div>
</div>
